const TournamentStatisticsTypes = {
    GET_TOURNAMENT_STATISTICS_START:'GET_TOURNAMENT_STATISTICS_START',
    GET_TOURNAMENT_STATISTICS_SUCCESS:'GET_TOURNAMENT_STATISTICS_SUCCESS',
    GET_TOURNAMENT_STATISTICS_FAILED:'GET_TOURNAMENT_STATISTICS_FAILED',

}

export default TournamentStatisticsTypes